import moment from "moment";
import React, { useState } from "react";
import ReactDatePicker from "react-datepicker";
import Select from "react-select";
import { Col, Label, Row } from "reactstrap";
import { CalenderIcon, DeleteIcon } from "../../../Icon";
import { RedDeleteIcon } from "../../../../assets/images";
import DatePicker from "react-datepicker";
import { currentDate } from "../../../../utils/commonFunctions";

type AppProps = {
  interviewerInputDetails: any;
  handleRemoveRow: (data: any) => void;
  recruiterLimit: number;
  recruiterOffset: number;
  recruiterText: string;
  finalRecruiterList: any;
  Option: any;
  userFetching: boolean;
  setRecruiterText: React.Dispatch<React.SetStateAction<string>>;
  setRecruiterOffset: React.Dispatch<React.SetStateAction<number>>;
  handleInterviewsInputDetailsChange: (
    dataKey: any,
    value: any,
    index: number
  ) => void;
};

const AddMoreInterviewerDetails = ({
  interviewerInputDetails,
  handleRemoveRow,
  recruiterLimit,
  recruiterOffset,
  recruiterText,
  finalRecruiterList,
  setRecruiterText,
  setRecruiterOffset,
  userFetching,
  Option,
  handleInterviewsInputDetailsChange,
}: AppProps) => {
  const checkBottom = (e: any) => {
    setRecruiterOffset((prv: any) => prv + recruiterLimit);
  };
  const renderInterviewerDetailsInput = () => {
    let arr: any[] = [];
    interviewerInputDetails?.map((item: any, i: number) => {
      if (item?.hasOwnProperty("interviewDateAndTime")) {
        let minDate = undefined;
        let minTime = undefined;
        let maxTime = undefined;

        if (i > 0 && interviewerInputDetails[i - 1]?.interviewDateAndTime) {
          const prevInterviewDateTime = new Date(
            interviewerInputDetails[i - 1]?.interviewDateAndTime
          );
          const currentDate = new Date(
            interviewerInputDetails[i]?.interviewDateAndTime
          );

          if (currentDate.getDate() === prevInterviewDateTime.getDate()) {
            const today = new Date();
            const todayFormatted = new Date(
              today.getFullYear(),
              today.getMonth(),
              today.getDate()
            );

            minDate = new Date(prevInterviewDateTime.getTime() + 1000); // Increment by 1 second
            minTime = prevInterviewDateTime;
            maxTime = moment(prevInterviewDateTime).endOf("day").toDate();
          }
        }

        arr.push(
          <>
            <div className="row mt-3">
              <div className="col-md-3">
                <label className="mb-1" htmlFor="phoneScreeningDateAndTime">
                  Interview Date & Time
                </label>
                <div className="form-group">
                  <div className="date-picker-wraper mr-0">
                    <Label className="m-0 p-0 w-100">
                      <DatePicker
                        dateFormat="dd-MM-yyyy"
                        disabled={item?.interviewFeedback}
                        minDate={
                          minDate ||
                          new Date(
                            moment(
                              `${currentDate()}T00:00:00`,
                              "YYYY-MM-DD"
                            ).format("YYYY-MM-DD[T]HH:mm:ss")
                          )
                        }
                        minTime={minTime}
                        maxTime={maxTime}
                        selected={
                          item?.interviewDateAndTime
                            ? new Date(
                                moment(
                                  `${item?.interviewDateAndTime}T00:00:00`,
                                  "YYYY-MM-DD, HH:mm"
                                ).format("YYYY-MM-DD[T]HH:mm:ss")
                              )
                            : null
                        }
                        onChange={(e: any) => {
                          handleInterviewsInputDetailsChange(
                            "interviewDateAndTime",
                            moment(e).format("YYYY-MM-DD, HH:mm"),
                            i
                          );
                        }}
                        fixedHeight
                        showMonthDropdown
                        value={item?.interviewDateAndTime}
                        showYearDropdown
                        name="phoneScreeningDateAndTime"
                        placeholderText="Choose"
                        className={`${
                          item?.interviewDateAndTimeError
                            ? "error-border rounded form-control"
                            : "form-control"
                        }`}
                        showTimeSelect={
                          item?.interviewDateAndTime ? true : false
                        }
                        timeFormat="HH:mm"
                      />
                      <span
                        className="calender-icon"
                        style={{
                          right: "30px",
                          top: "30px",
                          cursor: "pointer",
                        }}
                      >
                        <CalenderIcon />
                      </span>
                    </Label>
                  </div>
                </div>
                {/* {item?.interviewDateAndTimeError && (
                  <small
                    className="text-danger"
                    style={{
                      position: "absolute",
                      top: "66px",
                      fontSize: "12px",
                      left: "15px",
                    }}
                  >
                    {item?.interviewDateAndTimeError
                      ? item?.interviewDateAndTimeError
                      : ""}
                  </small>
                )} */}
              </div>
              <div className="col-md-3">
                <label className="mb-1" htmlFor="">
                  Interviewer
                </label>
                <Select
                  // styles={dropDownStyle}
                  isDisabled={item?.interviewFeedback}
                  value={item?.interviewers}
                  options={finalRecruiterList}
                  components={{ Option }}
                  onChange={(e) =>
                    handleInterviewsInputDetailsChange("interviewers", e, i)
                  }
                  isSearchable={true}
                  isLoading={userFetching && recruiterText?.length > 0}
                  onMenuClose={() => {
                    setRecruiterOffset(0);
                  }}
                  onMenuScrollToBottom={(e: any) => checkBottom(e)}
                  // isDisabled={isDisabled}
                  onInputChange={(e) => {
                    setRecruiterText(e);
                  }}
                  className={`${
                    item?.interviewersError ? "error-border rounded" : ""
                  }`}
                />
                {/* {item?.interviewersError && (
                  <small
                    className="text-danger"
                    style={{
                      position: "absolute",
                      top: "66px",
                      fontSize: "12px",
                      left: "15px",
                    }}
                  >
                    {item?.interviewersError ? item?.interviewersError : ""}
                  </small>
                )} */}
              </div>
              <div className="col-md-5">
                <label className="mb-1" htmlFor="interviewFeedback">
                  Interview Feedback
                </label>
                <div>
                  <textarea
                    disabled
                    className={`form-control`}
                    name="interviewFeedback"
                    onChange={(e) =>
                      handleInterviewsInputDetailsChange(
                        "interviewFeedback",
                        e.target.value,
                        i
                      )
                    }
                    value={item?.interviewFeedback}
                    // disabled={isDisabled}
                  />
                </div>
              </div>
              <span className="d-flex align-items-center">
                {interviewerInputDetails?.length > 1 &&
                item?.interviewFeedback?.length === 0 ? (
                  <span>
                    <img
                      className="pointer"
                      src={RedDeleteIcon}
                      onClick={() => handleRemoveRow(i)}
                      alt="remove"
                    />
                  </span>
                ) : null}
              </span>
            </div>
          </>
        );
      }
    });
    return arr;
  };
  return <>{renderInterviewerDetailsInput()}</>;
};

export default AddMoreInterviewerDetails;
